import React, { memo } from 'react'
import { Typography } from 'transfix-ui/core'
import { INoteableTypes } from 'types/graphqlTypes'
import Notes from 'apps/marketplace/components/Notes'

export interface ICarrierOptionActivityProps {
  optionId?: string
}

const CarrierOptionActivity = memo<ICarrierOptionActivityProps>(({ optionId }) => {
  return (
    <div>
      <Typography variant='h3' component='div'>
        Activity
      </Typography>
      {optionId && (
        <Notes
          hideFileAttachments
          noteableId={optionId}
          noteableType={INoteableTypes.Bid}
          disableFilters
          disableCallback
          disableHeader
          disableBorder
          inputLocation='bottom'
          issue={undefined}
        />
      )}
    </div>
  )
})

export default CarrierOptionActivity
